/**
 * ChatEmptyState - Shown when there are no messages yet
 */

import { MessageCircle } from 'lucide-react'

interface ChatEmptyStateProps {
  photographerName?: string
}

export default function ChatEmptyState({ photographerName }: ChatEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-4 text-gray-400">
      <MessageCircle className="w-12 h-12 mb-3 text-gray-300" />
      <p className="font-medium text-gray-600">No messages yet</p>
      <p className="text-sm mt-1">
        Send a message to {photographerName || 'your photographer'} to get started!
      </p>
    </div>
  )
}
